import React from 'react';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input from '@cloudscape-design/components/input';

export function AdminTokenField({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return (
    <Container
      header={<Header variant="h2">Internal admin token</Header>}
      footer={
        <Box color="text-body-secondary" fontSize="body-s">
          Required to submit changes under a non-Marketplace organisation. Ncoda engineers only.
        </Box>
      }
    >
      <FormField label="INTERNAL_ADMIN_TOKEN">
        <Input type="password" value={value} onChange={event => onChange(event.detail.value)} />
      </FormField>
    </Container>
  );
}
